const KEY = 'ms:haptics';

export function hapticsEnabled() {
    try {
        const v = localStorage.getItem(KEY);
        return v === null ? true : v === '1';
    } catch {
        return false;
    }
}

export function setHapticsEnabled(on) {
    try {
        localStorage.setItem(KEY, on ? '1' : '0');
    } catch { /* ignore */ }
}

/**
 * Whether `navigator.vibrate` exists at all — WKWebView (iOS, including the
 * Capacitor app) is the one place it is genuinely undefined, so the setting
 * toggle used to render there for a feature with no effect. This does not
 * distinguish "will actually buzz" from "API present but no vibration
 * hardware" (verified live: desktop Chromium exposes the function too) — it
 * only rules out the platform where the function itself does not exist.
 * Real haptic support via a Capacitor plugin would show up as a different
 * API, not this one, so this is a feature check, not a platform-name check.
 */
export function supportsHaptics() {
    return typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function';
}

/** Light tap when the device supports Vibration API and the user left haptics on. */
export function haptic(ms = 12) {
    if (!hapticsEnabled()) return;
    try {
        if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
            navigator.vibrate(ms);
        }
    } catch { /* ignore */ }
}
